import { Flex } from '@repo/ui/Flex';
import { Box } from '@repo/ui/Box';

import s from './ReviewLayout.module.css';
import { Layout } from '../../components/Layout/Layout';
import { Step } from '../../components/Step/Step';
import { Page } from '../../components/Page/Page';
import { Text } from '../../components/Language/Language';
import { useWorkflow } from '../../workflow/hooks';

export const ReviewLayout = () => {
  const { refundAmount } = useWorkflow();
  const amount = refundAmount?.formattedString ?? null;
  return (
    <Page>
      <Layout>
        <Box isContainer>
          <Flex
            direction="column"
            gap={['md:g-48', 'g-32']}
            padding={['md:px-0', 'px-16']}
          >
            <div className={s.headerContainer}>
              <h1 className={s.header}>
                <Text langKey="pdx.review.page_header" />
              </h1>
              {amount && (
                <div className={s.subheader}>
                  <Text
                    langKey="pdx.review.page_description"
                    replacementTokens={{ amount: amount ?? '' }}
                  />
                </div>
              )}
            </div>
            <div className={s.content}>
              <Step formId="ReviewStepForm" className={s.layout} />
            </div>
          </Flex>
        </Box>
      </Layout>
    </Page>
  );
};
